/** The reflections review — every reflection written, newest first.
 *
 *  The day view answers "what did I write about this day". This answers "what
 *  have I been writing", which is the question a review actually asks, and the
 *  only one that does not require already knowing the date.
 *
 *  Paged by `before` rather than an offset: reflections are keyed by journal
 *  date, so the cursor is a date and a page is stable even when a day written
 *  earlier in the range gains its first reflection mid-scroll.
 */
import { request, type Session } from './client';
import type { WireReflection } from './wire';

export interface ReflectionPage {
  items: WireReflection[];
  /** Absent when this is the last page. */
  nextCursor: string | null;
}

export const REFLECTION_PAGE_SIZE = 20;

export async function listReflections(
  session: Session,
  before?: string | null,
): Promise<ReflectionPage> {
  const query = new URLSearchParams({ limit: String(REFLECTION_PAGE_SIZE) });
  if (before) query.set('before', before);
  const { body } = await request<{ items: WireReflection[]; next_cursor?: string | null }>(
    session,
    `/v1/reflections?${query.toString()}`,
  );
  return { items: body.items ?? [], nextCursor: body.next_cursor ?? null };
}
